// Modal backdrop dismiss guard.
//
// Modals across the app close when you "click outside" (on the backdrop).
// The naive `@click.self="close()"` handler also fires when you press the
// mouse down *inside* a field, drag to select text, and release on the
// backdrop — the browser dispatches the resulting `click` on the common
// ancestor (the backdrop), closing the modal unexpectedly.
//
// We track where each pointer gesture *starts* so backdrop handlers can
// require that the press began on the backdrop too — i.e. a real click
// outside, not a text-selection drag that merely ended there.
//
// Usage in markup:
//   @click.self="if (window.backdropDismiss($event)) { close() }"
//   @click.outside="if (window.backdropDismissOutside($el)) { close() }"

let pressTarget = null

// pointerdown (not mousedown) so touch + pen taps are tracked too — otherwise
// tap-to-close on the backdrop would break on touch devices. Capture phase so
// we always see the true origin before any handler runs.
document.addEventListener(
  "pointerdown",
  (event) => {
    pressTarget = event.target
  },
  true,
)

// True when the current gesture both started and ended on the backdrop element
// the handler is bound to (`$event.currentTarget`). Pair with `.self` so the
// click target is already guaranteed to be the backdrop itself.
window.backdropDismiss = function (event) {
  return pressTarget === event.currentTarget
}

// Variant for `@click.outside` handlers, where the directive sits on the panel
// rather than the backdrop. Dismiss only if the press started outside the
// panel too.
window.backdropDismissOutside = function (panelEl) {
  return !!panelEl && !panelEl.contains(pressTarget)
}
